(function($, undefined) {
	'use strict';

	var init = function() {
		var navCardsComponents = $('.com-navigation-cards');

		if (navCardsComponents.length > 1) {
			if ($('.navigation-card_active', navCardsComponents).length > 1) {
				$('.navigation-card_active', navCardsComponents).not(":eq(0)").addClass("navigation-card_disabled");
			}
		}

		$('.navigation-cards_slider').each(function(i, el) {
			initSlider($(el));
		});
	};

	function initSlider(slider) {
		const context = slider.closest('.com-navigation-cards');
		const prevArrow = $('.navigation-cards__nav-arrow_prev', context);
		const nextArrow = $('.navigation-cards__nav-arrow_next', context);
		slider.slick({
			infinite: false,
			slidesToShow: 1.8,
			slidesToScroll: 1,
			dots: false,
			prevArrow,
			nextArrow,
			variableWidth: true
		});
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
